// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  ChromeOutlined,
  SettingOutlined,
  LoginOutlined,
  ProjectOutlined,
  DashboardOutlined,
  ApiOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  ChromeOutlined,
  SettingOutlined,
  LoginOutlined,
  ProjectOutlined,
  DashboardOutlined,
  ApiOutlined,
  FileSearchOutlined,
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other: NavItemType = {
  id: "other",
  type: "group",
  children: [
    // {
    //   id: "dashboard",
    //   title: <FormattedMessage id="dashboard" />,
    //   type: "item",
    //   url: "/dashboard",
    //   icon: icons.DashboardOutlined,
    // },
    {
      id: "projects",
      title: <FormattedMessage id="projects" />,
      type: "item",
      url: "/projects",
      icon: icons.ProjectOutlined,
    },
    {
      id: "apiReference",
      title: <FormattedMessage id="apiReference" />,
      type: "item",
      url: "/api-reference",
      icon: icons.ApiOutlined,
    },
    // {
    //   id: "usageLogs",
    //   title: <FormattedMessage id="usageLogs" />,
    //   type: "item",
    //   url: "/usage-logs",
    //   icon: icons.FileSearchOutlined,
    // }
    // {
    //   id: "login",
    //   title: <FormattedMessage id="login" />,
    //   type: "item",
    //   url: "/login",
    //   icon: icons.ChromeOutlined,
    // },
    // {
    //   id: "settings",
    //   title: <FormattedMessage id="settings" />,
    //   type: "item",
    //   url: "/settings",
    //   icon: icons.ChromeOutlined,
    // },
  ],
};

export default other;
